module.exports = __webpack_public_path__ + "static/media/qsaude.6fd91b42.svg";